<script>
//Importing Bar class from the vue-chartjs wrapper
import { Bar } from 'vue-chartjs'
import Axios from "axios";
//Exporting this so it can be used in other components
export default {
  extends: Bar,
  props: {
    chk_date_end_date: {
      default: 1
    }
  },
  data () {
    return {
      datacollection: {
        //Data to be represented on x-axis
        labels: [],
        datasets: [
          {
            label: '# of',
            backgroundColor:  [
              'rgba(255, 99, 132, 0.4)',
              'rgba(151,187,205,0.4)',
              'rgba(70,191,189,0.4)',
              'rgba(253,180,92,0.4)',
              'rgba(148,159,177,0.4)',
              'rgba(77,83,96,0.4)',
              'rgba(255, 159, 64, 0.4)',
              'rgba(255, 99, 132, 0.4)',
              'rgba(151,187,205,0.4)',
              'rgba(70,191,189,0.4)',
              'rgba(253,180,92,0.4)',
              'rgba(148,159,177,0.4)',
              'rgba(77,83,96,0.4)',
              'rgba(255, 159, 64, 0.4)',
              'rgba(255, 99, 132, 0.4)',
              'rgba(151,187,205,0.4)',
              'rgba(70,191,189,0.4)',
              'rgba(253,180,92,0.4)',
              'rgba(148,159,177,0.4)',
              'rgba(77,83,96,0.4)',
              'rgba(255, 159, 64, 0.4)',
              'rgba(255, 99, 132, 0.4)',
              'rgba(151,187,205,0.4)',
              'rgba(70,191,189,0.4)',
              'rgba(253,180,92,0.4)',
              'rgba(148,159,177,0.4)',
              'rgba(77,83,96,0.4)',
              'rgba(255, 159, 64, 0.4)',
              'rgba(255, 99, 132, 0.4)',
              'rgba(151,187,205,0.4)',
              'rgba(70,191,189,0.4)',
              'rgba(253,180,92,0.4)',
              'rgba(148,159,177,0.4)',
              'rgba(77,83,96,0.4)',
              'rgba(255, 159, 64, 0.4)',
              'rgba(255, 99, 132, 0.4)',
              'rgba(151,187,205,0.4)',
              'rgba(70,191,189,0.4)',
              'rgba(253,180,92,0.4)',
              'rgba(148,159,177,0.4)',
              'rgba(77,83,96,0.4)',
              'rgba(255, 159, 64, 0.4)',
              'rgba(255, 99, 132, 0.4)',
              'rgba(151,187,205,0.4)',
              'rgba(70,191,189,0.4)',
              'rgba(253,180,92,0.4)',
              'rgba(148,159,177,0.4)',
              'rgba(77,83,96,0.4)',
              'rgba(255, 159, 64, 0.4)',
              'rgba(255, 99, 132, 0.4)',
              'rgba(151,187,205,0.4)',
              'rgba(70,191,189,0.4)',
              'rgba(253,180,92,0.4)',
              'rgba(148,159,177,0.4)',
              'rgba(77,83,96,0.4)',
              'rgba(255, 159, 64, 0.4)'
            ],   //E1F3D
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#E1F3D8',
            //Data to be represented on y-axis
            // borderColor: [
            //   'rgba(255, 99, 132, 1)',
            //   'rgba(54, 162, 235, 1)',
            //   'rgba(255, 206, 86, 1)',
            //   'rgba(75, 192, 192, 1)',
            //   'rgba(153, 102, 255, 1)',
            //   'rgba(255, 159, 64, 1)'
            // ],
            data: [],

          }
        ]
      },
      //Chart.js options that controls the appearance of the chart
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize : 1,
              // fontColor : "rgba(251, 203, 9, 1)",
              fontSize : 8,
            },
            gridLines: {
              display: true,

            }
          }],
          xAxes: [ {
            gridLines: {
              display: false,
            },

            ticks: {
              beginAtZero: true,
              stepSize : 1,
              // fontColor : "rgba(251, 203, 9, 1)",
              fontSize : 8,
            },
          }]
        },
        legend: {
          display: false // 도시별
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  mounted () {
    //renderChart function renders the chart with the datacollection and options object.

    //
  },

  created() {
    this.search();
    // this.renderChart(this.datacollection, this.options)

  },

  watch: {
    chk_date_end_date: function (value) {
      if (value != null)
        this.search();
    }
  },

  methods: {

    async search(customStartDate, customEndDate){
      this.loading = true;
      // default data
      let url = this.$url + '/authInfo/getAreaReportAuth';
      var reqJson = new Object();

      if (this.$store.state.accessToken != '100')
        reqJson.rfid_get_order_seq = this.$store.state.rfid_get_order_seq;

      if (customStartDate && customEndDate) {
        reqJson.custom_start_date = customStartDate;
        reqJson.custom_end_date = customEndDate;
      } else if (this.chk_date_end_date != null && this.chk_date_end_date != '0') {
        reqJson.chk_date_end_date = this.chk_date_end_date;
      }


      await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
        var resDataJson = res.data.authInfoDTO;

        //console.log("'===================================================================='") ;
        //console.log(resDataJson) ;

        this.datacollection.labels = [];
        this.datacollection.datasets[0].data = [];

        for(var resData in resDataJson){
          this.datacollection.labels[resData] = resDataJson[resData]['administrative_area_level_1']
          this.datacollection.datasets[0].data[resData] =  resDataJson[resData]['count'] * 1
        //
        //
        //   // this.datacollection.datasets.push ({
        //   //   data :   resDataJson[resData]['count'] ,
        //   // });
        //
        }

        this.renderChart(this.datacollection, this.options) // datacollection 과 options 객체를 파라미터로 보내서 차트를 render 하는 renderChart()함수를 부릅니다

        this.loading = false;
      }) // await Axios.post
          .catch(error => {
            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }); // await Axios.post
    },//chkQrCode
  },
}
</script>
